export const name = "GENERATE_UUID";
export const summary = `Produces a random universally unique identifier (UUID) as a \`STRING\` value.`;
export const reference = `
## GENERATE_UUID

Produces a random universally unique identifier (UUID) as a \`STRING\` value.

\`\`\`
GENERATE_UUID()
\`\`\`

### Description

Returns a random universally unique identifier (UUID) as a \`STRING\`. The returned \`STRING\` consists of 32 hexadecimal digits in five groups separated by hyphens in the form 8-4-4-4-12. The hexadecimal digits represent 122 random bits and 6 fixed bits, in compliance with RFC 4122 section 4.4. The returned \`STRING\` is lowercase.


### Return Data Type

STRING


### Example

The following query generates a random UUID.



\`\`\`
SELECT GENERATE_UUID() AS uuid;

/*--------------------------------------*
 | uuid |
 +--------------------------------------+
 | 4192bff0-e1e0-43ce-a4db-912808c32493 |
 *--------------------------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/utility-functions
`;
